import SectionTitle from "@/components/base/SectionTitle";
import { methodSteps } from "@/mocks/site";

export default function MethodSection() {
  return (
    <section className="w-full bg-primary-950 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <SectionTitle
          eyebrow="Method"
          title="一份档案是怎么做出来的"
          description="我们不靠爆料，靠的是把公开信息按顺序摆好，让逻辑自己说话。"
          light
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {methodSteps.map((item) => (
            <div
              key={item.step}
              className="p-5 md:p-6 rounded-lg bg-primary-900/60 border border-primary-800"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="font-heading text-2xl font-black text-primary-700">
                  {item.step}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-background-50">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-background-300">{item.desc}</p>
            </div>
          ))}
        </div>

        <p className="mt-8 text-xs md:text-sm leading-relaxed text-background-400 max-w-3xl">
          说明：本站所有分析均基于公开信息与一般性规律归纳，不对任何未被权威机构认定的具体个人作出事实判断。若你正在经历网暴，请优先保存证据并寻求专业法律与心理支持。
        </p>
      </div>
    </section>
  );
}